type Listener = () => void;

let pending = 0;
const listeners = new Set<Listener>();

function emit() {
  for (const listener of listeners) listener();
}

export function getPendingRequests(): number {
  return pending;
}

export function subscribePending(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Open the veil. Call the returned function when the response has settled. */
export function beginWait(): () => void {
  pending += 1;
  emit();
  let ended = false;
  return () => {
    if (ended) return;
    ended = true;
    pending -= 1;
    emit();
  };
}

export function loaderIsOpen(splash: boolean, pendingCount: number): boolean {
  return splash || pendingCount > 0;
}

function skipsLoader(input: RequestInfo | URL): boolean {
  const url =
    typeof input === "string"
      ? input
      : input instanceof URL
        ? input.href
        : input.url;
  return url.includes("/__lift/harness");
}

export function watchFetch(original: typeof fetch): typeof fetch {
  return (input, init) => {
    if (skipsLoader(input)) return original(input, init);
    const end = beginWait();
    try {
      return Promise.resolve(original(input, init)).finally(end);
    } catch (error) {
      end();
      throw error;
    }
  };
}

let fetchWatchInstalled = false;

export function installFetchLoader(): void {
  if (typeof window === "undefined" || fetchWatchInstalled) return;
  fetchWatchInstalled = true;
  window.fetch = watchFetch(window.fetch.bind(window));
}

export function resetLoaderActivity(): void {
  pending = 0;
  emit();
}
